import React, { useEffect, useState } from 'react'
import {  Button,Table, Spinner, Row, Col, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import {  toast } from 'react-toastify';
import { updateUser, getUserToEdit } from '../../services/Users/EditUser'
import { getRoles } from '../../services/Other/GeneralQueries';



function EditUser(){
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [roles, setRoles] = useState([]); 
    const [formData, setFormData] = useState({
        email: '', 
        username: '',
        roleId: '0',        
      });
      const redirectBack = () => {
        navigate(`/users`);
      }
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };

      const handleSubmit = (e) => {
        e.preventDefault();             
        let email = formData.email;
        let userName = formData.username;        
        let roleId = parseInt(formData.roleId);           
        if(email && userName && roleId)
        {      
          updateUser(id, email, userName, roleId).then(updateResult => {
              if(updateResult)
              {
                toast.success('Usuario actualizado correctamente');
              }
              else
              {
                toast.error('Lo sentimos, algo salió mal.');
              }
          })                                 
        }
        else
        {
            console.log("else")
        }

      };
      
  useEffect(() => {
    getUserToEdit(id).then(usr=> {
      setFormData({
        email: usr.email || '',
        username: usr.userName || '',
        roleId: usr.roleId || 0,           
      });
    }).finally(() =>{
      setIsLoading(false);
    })    
    getRoles().then(list=> {
      setRoles(list);
    }).finally(()=>{

    })

  }, []);

  return (
    <div>
      { isLoading ? (
        <Spinner animation="border" role="status" />
      ) : (

        <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formEmail">
          <Form.Label>Email:</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </Form.Group>
        <Form.Group className='mt-3' controlId="formUsername">
          <Form.Label>Username:</Form.Label>
          <Form.Control
            type="text"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
            required
          />
        </Form.Group>            
        <Form.Group className='mt-3' controlId="formRole">
          <Form.Label>Rol:</Form.Label>
          <Form.Control
            as="select"
            name="roleId"
            value={formData.roleId}
            onChange={handleInputChange}
          >
           {roles.map((role) => (
                <option key={role.id} value={role.id}>{role.name}</option>
              ))}
          </Form.Control>
        </Form.Group>             
        <Row>
            <Col xl={12} className='text-center'>
                <Button className='m-3' variant="secondary" type="button" onClick={redirectBack} >
                    Cancelar
                </Button>
                <Button className='m-3' variant="primary" type="submit">
                    Actualizar información
                </Button>
            </Col>
        </Row>
      </Form>
      
      )}      
    </div>
  );
}

export default EditUser
